<template>
    <div>
        <table class="table table-bordered" border="0" style="width: 100%; border-collapse: collapse; margin-top: 10px">
        <tr>
            <td style="width: 40%; padding: 0">
                <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="1" style="border-collapse: collapse;  border-bottom: none; padding: 0; float: right; text-align:right;" >
                    <tr>
                        <td style="height: 25px; text-align: right;">SubTotal:</td>
                        <td style="height: 25px">{{ getSubTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                    </tr>
                    <tr>
                        <td style="height: 25px; text-align: right; border-bottom: none">Desconto:</td>
                        <td style="height: 25px; border-bottom: none">{{ getTotalDiscount | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                    </tr>
                    <tr style="height: 10px"></tr>
                    <tr>
                        <td style="height: 25px; text-align: right; font-weight:bold; border-bottom: none">Total:</td>
                        <td style="height: 25px; border-bottom: none">{{ total | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                    </tr>
                    <tr>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    <v-flex xs12 v-if="fetchedInvoice.detail">
        <v-divider></v-divider>
        <p style="font-size: 12px; margin-bottom: 2px">Obs: {{fetchedInvoice.detail}}</p>
    </v-flex>
    </div>
</template>

<script>
    export default {
        created () {
            
        },

        data(){
            return {

            }
        },

        watch: {
            
        },
        
        props:{
            total: {
                type: Number,
                default: 0,
            },
            fetchedInvoice: {
               type: Object,
               default: () => ({}),
            },
            sellLines: {
                type: Array,
                default: () => [],
            },
            isInvoiceA5Format: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            getSubTotal(){
                let mSubtotal = 0;

                for(let i=0; i<this.sellLines.length; i++){
                    let sellLine = this.sellLines[i];
                    let soldQuantity = sellLine.sold_quantity ? sellLine.sold_quantity : 0;
                    let quantityToBeDelivered = !sellLine.quantity_to_be_delivery ? 0 : sellLine.quantity_to_be_delivery;

                    let subtotalNoDiscount = sellLine.sell_price * (soldQuantity);
                    mSubtotal += subtotalNoDiscount;

                }

                return mSubtotal;
            },

            getTotalDiscount(){
                // return this.getSubTotal - this.total;

                let totalDiscountValue = 0;
                let mSubtotal = 0;

                for(let i=0; i<this.sellLines.length; i++){
                    let sellLine = this.sellLines[i];
                    let soldQuantity = !sellLine.sold_quantity ? 0 : sellLine.sold_quantity;
                    let quantityToBeDelivered = !sellLine.quantity_to_be_delivery ? 0 : sellLine.quantity_to_be_delivery;

                    let subtotalNoDiscount = sellLine.sell_price * (soldQuantity + quantityToBeDelivered);
                    mSubtotal += subtotalNoDiscount;

                    let percentageDiscount = subtotalNoDiscount * sellLine.discount / 100;
                    totalDiscountValue += percentageDiscount;
                }

                return totalDiscountValue;
            },
        },

        methods: {
            
        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }


</style>